'use client'

import React from 'react'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const Tariff: React.FC = () => {
	const { openConsultationModal } = useModal()

	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.heading}>
					<Typography variant='h4' color='accent' className={styles.subtitle}>
						Тарифы
					</Typography>
					<Typography variant='h2' className={styles.title}>
						Прозрачная стоимость лицензий
					</Typography>
				</div>
			</AnimatedSection>
			<AnimatedSection animation="slideUp">
				<Table />
			</AnimatedSection>
			<AnimatedSection animation="slideUp">
				<div className={styles.infoCard}>
					<h3 className={styles.infoCardTitle}>Закрытый контур</h3>
					<p className={styles.infoCardDescription}>
						Если у вашей компании есть строгие требования к безопасности, мы развернём решение локально на ваших собственных серверах (On-Premise). Стоимость проекта в этом случае рассчитывается индивидуально под архитектуру вашего ИТ-контура.
					</p>
					<button className={styles.infoCardButton} onClick={openConsultationModal}>
						<span className={styles.infoCardButtonText}>Оставить заявку</span>
					</button>
				</div>
			</AnimatedSection>
		</section>
	)
}

const tableData = {
	columns: ['', '6 месяцев', '12 месяцев'],

	rows: [
		{
			cells: [
				'Размещение системы',
				'На выделенном сервере</span><br><span class="priceExtra">входит в стоимость</span>',
				'На выделенном сервере</span><br><span class="priceExtra">входит в стоимость</span>'
			]
		},
		{
			cells: [
				'Стоимость',
				'<span class="price">75 000 ₽</span>',
				'<span class="price">150 000 ₽</span>'
			]
		},
		{
			cells: [' ',
				'btn',
				'btn'
			]
		}
	]
}

const Table: React.FC = () => {
	const { openConsultationModal } = useModal()

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead>
					<tr>
						{tableData.columns.map((col, i) => (
							<th key={i}>
								<Typography variant="p1" color="main">
									{col}
								</Typography>
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{tableData.rows.map((row, rowIndex) => (
						<tr key={rowIndex}>
							{row.cells.map((cell, colIndex) => (
								<td key={colIndex}>
									{cell === 'btn' ? (
										<button
											className={styles.btn}
											onClick={openConsultationModal}
										>
											<span className={styles.btnText}>Оставить заявку</span>
										</button>
									) : typeof cell === 'string' && cell.endsWith('.svg') ? (
										<img src={cell} alt="" className={styles.cellIcon} />
									) : typeof cell === 'string' ? (
										<div
											className={styles.cellHtml}
											dangerouslySetInnerHTML={{ __html: cell }}
										/>
									) : (
										cell
									)}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}

Tariff.displayName = 'Tariff'

export default Tariff
